import React, { useState } from 'react';
import MainnetProgress from './MainnetProgress'; 
import HalvingCarousel from './HalvingCarousel'; 
import RewardDistribution from './RewardDistribution';
import ProjectFundingAllocation from './ProjectFundingAllocation';
import Supply from './Supply';
import '../css/Tokenomics.css'; 

const Tokenomics = () => {
  const [triggerAllocation, setTriggerAllocation] = useState(false);

  const handleFundingTriggered = () => {
    setTriggerAllocation(true);
  };

  return (
    <div className="tokenomics-page">
        <h1>Tokenomics</h1>
      <h2>Total supply & Distribution strategie</h2>
      <div className="tokenomics-row">
      <div className="tokenomics-supply-row">
      <Supply />
      </div>
      <RewardDistribution onFundingTriggered={handleFundingTriggered} />
      <ProjectFundingAllocation triggerAnimation={triggerAllocation} />
      </div>
      <MainnetProgress />
      <HalvingCarousel />

    </div>
  );
};

export default Tokenomics;
